import React, { FC, useState } from 'react';
import { Customer, PageWrapper, CustomerForm, useShowAlertPopup } from '@dew21/ui';
import axios from 'axios';
import { useHistory } from 'react-router';

export const AddCustomer: FC = (props) => {
  const [customer, setCustomer] = useState<Customer | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();

  return <PageWrapper
    breadCrumb={[{ title: 'Kunden', path: '/customers' }, { title: 'Hinzufügen', path: `/customers/add` }]}
    marginal={{
      items: [],
    }}>
    <CustomerForm
      onCancel={() => {
        history.push('/customers');
      }}
      customer={customer}
      setCustomer={(customer: Customer) => {
        axios.post(`/api/customers/create`, customer).then((response) => {

          setCustomer(response.data);
          showNotificationBanner({ renderContent: () => <>Der Kunde wurde angelegt.</> });
          history.push('/customers');

        }).catch((error) => {
          showNotificationBanner({ error: true, renderContent: () => <>Bitte kontrolieren Sie ihre Eingaben.</> });
          console.log(error);
        });
      }} />
  </PageWrapper>;
};
